
import { NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { KitchenSharedModule } from '../shared/kitchen-shared.module';
import { CmSharedModule } from '../../shared/shared-module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReportBuilderComponent } from './components/builder/report-builder.component';
import { ReportBuilderMyReportsComponent } from './components/my-reports/report-builder-my-reports.component';
import { ReportBuilderConfigComponent } from './components/builder/report-builder-config.component';
import { ReportBuilderSharedReportsComponent } from './components/my-reports/report-builder-shared-reports.component';
import { ReportBuilderScheduledReportsComponent } from './components/my-reports/report-builder-scheduled-reports.component';
import { ReportBuilderService } from './report-builder.service';
import { ReportBuilderSavedReportsComponent } from './components/my-reports/report-builder-saved-reports.component';
import { UserReportConfigEditorDialogComponent } from './components/my-reports/user-report-config-editor-dialog.component';
import { ScheduledUserReportEditorDialogComponent } from './components/my-reports/scheduled-user-report-editor-dialog.component';
import { ReportPresetsComponent } from './components/presets/report-presets.component';
import { ReportPresetsGroupingByDaysComponent } from './components/presets/report-presets-grouping-by-days.component';
import { ReportPresetsImpressionsWidgetSizeByDayComponent } from './components/presets/report-presets-impressions-widget-size-by-day.component';
import { ReportActivityByDepartmentChartComponent } from './components/activity/report-activity-by-department-chart.component';
import { ReportActivityBySalesRepChartComponent } from './components/activity/report-activity-by-sales-rep-chart.component';
import { ReportActivityByStageChartComponent } from './components/activity/report-activity-by-stage-chart.component';
import { ReportActivityByTypeChartComponent } from './components/activity/report-activity-by-type-chart.component';
import { DownloadReportActivityDialogComponent } from './components/activity/download-report-activity-dialog.component';
import { ReportPresetsWinRateComponent } from './components/presets/report-presets-win-rate.component';
import { ReportPresetsDpLandscapeComponent } from './components/presets/report-presets-dp-landscape.component';
import { ReportPresetsNegativeProfitabilityUnitsComponent } from './components/presets/revops/report-presets-negative-profitability-units.component';
import { ReportPresetsNegativeMarginUnitsComponent } from './components/presets/revops/report-presets-negative-margin-units.component';
import { ReportPresetsReadyToActiveComponent } from './components/presets/adops/report-presets-ready-to-active.component';
import { ReportPresetsTopMissingAdstxtComponent } from './components/presets/adops/report-presets-top-missing-adstxt.component';
import { ReportPresetsBidderUnitsComponent } from './components/presets/revops/report-presets-bidder-units.component';
import { ReportPresetsEbdaUnitsComponent } from './components/presets/revops/report-presets-ebda-units.component';
import { ReportPresetsVideoUnitsComponent } from './components/presets/adops/report-presets-video-units.component';


@NgModule({
  imports: [
    RouterModule,
    KitchenSharedModule,
    CmSharedModule,
    BrowserAnimationsModule
  ],
  declarations: [
    ReportBuilderComponent,
    ReportBuilderConfigComponent,
    DownloadReportActivityDialogComponent,
    ReportBuilderSavedReportsComponent,
    ReportBuilderMyReportsComponent,
    ReportBuilderSharedReportsComponent,
    ReportBuilderScheduledReportsComponent,
    UserReportConfigEditorDialogComponent,
    ScheduledUserReportEditorDialogComponent,
    ReportPresetsComponent,
    ReportPresetsWinRateComponent,
    ReportPresetsEbdaUnitsComponent,
    ReportPresetsGroupingByDaysComponent,
    ReportPresetsDpLandscapeComponent,
    ReportPresetsNegativeProfitabilityUnitsComponent,
    ReportPresetsReadyToActiveComponent,
    ReportPresetsVideoUnitsComponent,
    ReportPresetsTopMissingAdstxtComponent,
    ReportPresetsBidderUnitsComponent,
    ReportPresetsNegativeMarginUnitsComponent,
    ReportPresetsImpressionsWidgetSizeByDayComponent,
    ReportActivityByDepartmentChartComponent,
    ReportActivityBySalesRepChartComponent,
    ReportActivityByStageChartComponent,
    ReportActivityByTypeChartComponent
  ],
  providers: [ReportBuilderService, DatePipe],
  entryComponents: [
    UserReportConfigEditorDialogComponent,
    ScheduledUserReportEditorDialogComponent,
    DownloadReportActivityDialogComponent
  ],
  exports: [
    RouterModule
  ]
})
export class ReportBuilderModule {
}
